<template>
  <div class="quick-search-header search-filter-header">
    <div class="multiple-options-selection">
      <div
        class="handler d-flex align-items-center justify-content-between form-control"
        @click.stop="toggleFilterMenu"
      >
        <div class="selected-option-count" v-if="false">
          {{ filter_options.filter((each) => each.selected).length }}
        </div>
        <div class="place-holder">
          {{ filter_options?.find((each) => each.selected)?.label }}
        </div>
        <img
          :src="require(`@/assets/images/icons/chevron-down.svg`)"
          alt="chevron-down"
          :style="{ transform: open_filter_menu ? 'rotate(180deg)' : '' }"
        />
      </div>
      <div
        v-if="open_filter_menu"
        v-click-outside="toggleFilterMenu"
        class="options p-3"
        :style="
          isLangRtl ? 'right: 0px; width: 185px' : 'left: 0px; width: 185px'
        "
      >
        <div
          v-for="(option, index) in filter_options"
          :key="index"
          :class="
            index < filter_options.length - 1
              ? 'option d-flex align-items-center cursor-pointer mb-2 pb-2'
              : 'cursor-pointer'
          "
          @click="selectSingleFilterOption(option)"
        >
          <input
            v-if="false"
            type="checkbox"
            :name="option.key"
            :checked="option.selected"
            class="me-2"
          />
          <div>
            {{ option?.label }}
          </div>
        </div>
      </div>
    </div>
    <div class="input-section">
      <validation-observer ref="observer">
        <base-select
          v-if="
            filter_options?.find((each) => each.selected)?.key === 'client' ||
            filter_options?.find((each) => each.selected)?.key === 'branch'
          "
          cus_style="width:300px"
          :remove_default_margin="true"
          id="manage-trip-list-search-text"
          :options="
            filter_options?.find((each) => each.selected)?.key === 'branch'
              ? $store.getters['enums/branch_enums']
              : $store.getters['enums/clients_list_enums']
          "
          field="search_text"
          :value="search_text"
          @change-value="setValue"
        >
        </base-select>
        <base-input
          v-else
          cus_style="width:300px"
          :remove_default_margin="true"
          id="manage-trip-list-search-text"
          :rules="inputRules"
          placeholder="search-here"
          field="search_text"
          :value="search_text"
          @change-value="setValue"
          @enter="search"
        />
      </validation-observer>
    </div>
    <div>
      <base-button
        variant="primary"
        id="reservation-list-search-btn"
        @click="search"
      >
        {{ $t("search") }}
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuickSearchHeader",
  emits: ["search"],
  data() {
    return {
      open_filter_menu: false,
      search_text: null,
      filter_options: [
        {
          key: "_id",
          label: this.$t("trip-id"),
          selected: true,
          type: "text",
        },
        {
          key: "reservation",
          label: this.$t("reservation-id"),
          selected: false,
          type: "text",
        },
        {
          key: "contract",
          label: this.$t("contract-id"),
          selected: false,
          type: "text",
        },
        {
          key: "route",
          label: this.$t("route-id"),
          selected: false,
          type: "text",
        },
        {
          key: "referenceNumber",
          label: this.$t("reference-id"),
          selected: false,
          type: "text",
        },
        {
          key: "client",
          label: this.$t("client-name"),
          selected: false,
          type: "dropdown",
        },
        {
          key: "branch",
          label: this.$t("branch"),
          selected: false,
          type: "dropdown",
        },
        {
          key: "employeeID",
          label: this.$t("drivers-id"),
          selected: false,
          type: "text",
        },
        {
          key: "operationalID",
          label: this.$t("vehicles-operation-id"),
          selected: false,
          type: "text",
        },
      ],
    };
  },
  methods: {
    toggleFilterMenu() {
      this.open_filter_menu = !this.open_filter_menu;
    },
    selectSingleFilterOption(option) {
      this.toggleFilterMenu();
      this.search_text = null;
      this.filter_options = this.filter_options?.map((each) => {
        if (option.key === each.key) each["selected"] = true;
        else each["selected"] = false;
        return each;
      });
    },
    setValue(val, field) {
      this[field] = val;
    },
    async search() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;
      this.$emit(
        "search",
        this.filter_options?.find((each) => each.selected).key,
        this.search_text
      );
    },
  },
  computed: {
    inputRules() {
      const selectedKey = this.filter_options?.find(
        (each) => each.selected
      )?.key;
      return selectedKey !== "referenceNumber"
        ? { integer: true, positive: true }
        : {};
    },
  },
};
</script>
<style lang="scss" scoped>
.quick-search-header {
  display: flex;
  align-items: center;
  justify-content: start;
  .input-section {
    margin-left: 8px;
    margin-right: 8px;
  }
}
.search-filter-header {
  .cursor-pointer {
    cursor: pointer;
  }
}
</style>
